<template>
  <div>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for="a_name">投诉人电话</label>
          <input
            v-model="search.phone"
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
               size="small"
            >
             查询
            </el-button>
          </span>
          <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
          <!-- <span class='add_btn'><button v-if="stationManger_btn_add" type="button" class="btn btn-default" id="addarea" @click="addrOrEdit()">添加</button></span> -->

          <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
     
      >
        <el-table-column
          show-overflow-tooltip
          label="投诉内容"
          prop="content"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="投诉人电话"
          prop="mobile"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="投诉时间"
          prop="crtTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="处理时间"
          prop="attr1"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="回复内容"
          prop="reply"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              class="operate-button edit"
              title="查看"
              href="javascript:;"
              @click="photo(scope.row.pics)"
            >
              查看图片
            </button>
            <button
              class="operate-button"
              type="button"
              :style="{
                color:
                  scope.row.status === 0
                    ? '#278cd8 !important'
                    : 'gray !important',
              }"
              @click="btnClickHandle(scope.row)"
            >
              处理
            </button>
            <!-- <button class="delete"   type="button">删除</button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <check-photo
      :dialogFormVisiblePhoto="dialogFormVisiblePhoto"
      :pics="allImgUrl"
      v-on:func="setDialogStatus"
    />
    <handler-modal
      :oneComplainMessage="oneComplainMessage"
      @func="tableList"
    ></handler-modal>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  complainList,
  lowerEquip,
  setHeartTime,
  getAllStationList,
  removeStation,
  editStation,
  addStation,
  getStationList,
  getAllParkingsByEnabled,
  getParkSingle,
  parkingBusType,
  dictValue,
  getCity,
  parkList,
  getRulesType,
  addOrUpdateChargeRule,
  getChargeRule,
  parkAdd,
  addMapOverlay,
  addMapOverlayl,
  setMapEvent,
  addMapControl,
  getManagerList,
} from "@/api/url";
import Page from "../../commons/page";
import CheckPhoto from "../../commons/checkPhoto";
import HandlerModal from "../components/handlerModal";
export default {
  data() {
    return {
      stationManger_btn_remove: false,
      stationManger_btn_add: false,
      stationManger_btn_edit: false,
      stationManger_btn_heart: false,
      dialogFormVisiblePhoto: false,
      oneComplainMessage: {
        dialogFormVisibleHandler: false,
        id: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      form: {
        stationId: "",
        stationName: "",
        stationSn: "",
        loraID: "",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        phone: "",
      },
      tableListData: [],
      tableListDataTitle: [],
      tableListDataExcel: {},
      allImgUrl: [],
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      rules: {
        stationSn: [
          { required: true, message: "请填写设备编号", trigger: "blur" },
        ],
        stationName: [
          { required: true, message: "请填写设备名称", trigger: "blur" },
        ],
      },
      pageObj: {},
      loading: false,
      
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    photo: function (pics) {
      this.dialogFormVisiblePhoto = true;
      this.allImgUrl = pics;
    },
    setDialogStatus() {
      this.dialogFormVisiblePhoto = false;
    },
    cancleHandlerModal() {
      this.dialogFormVisibleHandler = false;
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      _this.loading = true;
      _this.tableListDataTitle = [];
      _this.tableListData = [];
      this.$get(complainList(), {
        limit: this.search.pageSize,
        page: curPage,
        phone: this.search.phone,
      }).then((data) => {
        if (data.status != 200) {
          this.$layer.msg(data.message);
          return;
        }
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        const listData = data?.data?.rows ?? [];
        this.tableListData = listData.map((item) => {
          const mobile = JSON.parse(item?.userId ?? "{}")?.mobile ?? "";
          const pics = item.pics.split(",");
          return {
            content: item.content,
            crtTime: item.crtTime,
            mobile,
            pics,
            id: item.id,
            reply: item.reply,
            status: item.status,
            attr1:item.attr1
          };
        });
        this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
        
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
    
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    addrOrEdit: function (id) {
      if (Boolean(id)) {
        this.dialogFormVisible = true;
        this.$get(addStation() + "/" + id, { stationId: id }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.form.stationId = data.data.stationId;
          this.form.stationSn = data.data.stationSn;
          this.form.stationName = data.data.name;
          this.form.loraID = data.data.loraID;
        });
      } else {
        this.form.stationId = "";
        this.form.stationSn = "";
        this.form.stationName = "";
        this.form.loraID = "";
        this.dialogFormVisible = true;
      }
    },
    addrOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.stationId)) {
            _this
              .$postRequest(addStation(), {
                stationSn: _this.form.stationSn,
                name: _this.form.stationName,
                loraID: _this.form.loraID,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.tableList(_this.pageObj.curIndex);
              });
          } else {
            _this
              .$putRequest(editStation(), {
                stationId: _this.form.stationId,
                stationSn: _this.form.stationSn,
                name: _this.form.stationName,
                loraID: _this.form.loraID,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    del: function (id) {
      var _this = this;
      // console.log(id)
      var index = _this.$layer.confirm(
        "您确定删除该设备？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(removeStation() + "?stationId=" + id, {})
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.tableList(_this.search.pageNumber);
            });
        }
      );
    },
    btnClickHandle(item) {
      if (item.status === 1) {
        return;
      }
      this.oneComplainMessage.dialogFormVisibleHandler = true;
      this.oneComplainMessage.id = item.id;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.stationManger_btn_add = this.elements["stationManger:btn_add"];
      this.stationManger_btn_remove = this.elements["stationManger:btn_remove"];
      this.stationManger_btn_edit = this.elements["stationManger:btn_edit"];
      this.stationManger_btn_heart = this.elements["stationManger:btn_heart"];
    },
  },
  components: {
    Page,
    CheckPhoto,
    HandlerModal,
    // Refresh
  },
  created: function () {
    this.permiss;
    // this.vueMqtt.topic="topic/webstation/"+this.$route.query.id;
    //this.vueMqtt.topic="topic/webstation/#";
    // this.vueMqtt.topic="topic/webstation/#";
    // this.MQTTconnect();
    // this.vueMqtt.client.onConnectionLost = this.onConnectionLost;
    // this.vueMqtt.client.onMessageArrived = this.onMessageArrived;
  },
  mounted: function () {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);

    // this.tableListAll();
  },
  destroyed: function () {
    // this.vueMqtt.client.disconnect();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
</style>